import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.css'],
})
export class CustomModalComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() title: string = 'Modal Title';
  @Input() btnSubmitTitle: string = 'Submit';
  @Input() btnGoToTitle: string = 'Go to title';
  @Input() showMessage: boolean = true;
  @Input() promotionForm!: FormGroup;
  @Input() goToUrl: string = '';
  @Output() close = new EventEmitter<void>();
  @Output() formSubmit = new EventEmitter<void>();
  allDestinations: Array<any>;
  constructor(
    private root: Router,
    private apiService: ApiService,
  ) {}
  ngOnInit(): void {
    this.apiService.getDestination().subscribe({
      next: (dests) => {
        this.allDestinations = dests;
      },
      error: (err) => {
      },
    });
  }
  closeModal() {
    this.close.emit();
  }

  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }
  checkTermsAndConditions() {
    this.promotionForm.patchValue({
      checkConditions: !this.promotionForm.value.checkConditions,
    });
  }
  onFormSubmit() {
    this.formSubmit.emit();
  }
  goto(): void {
    this.root.navigateByUrl(this.goToUrl);
    this.closeModal();
  }

  // Helper method to safely check if a control is invalid and touched
  isFieldInvalid(fieldName: string): boolean {
    const control = this.promotionForm?.get(fieldName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  // Helper method to get error message
  getErrorMessage(fieldName: string): string | null {
    const control = this.promotionForm?.get(fieldName);
    if (!control || !control.errors) return null;

    if (control.errors['required']) return `${fieldName} is required.`;
    if (control.errors['email']) return 'Please enter valid email address.';

    return null;
  }
}
